module.exports = __webpack_public_path__ + "img/quiet_cove.c167d929.svg";